<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import ToastHost from '@/components/ToastHost.vue';
import { api } from '@/api/client';
import { useToast } from '@/composables/useToast';

const toast = useToast();

// Intercepta erros HTTP globais — qualquer falha sem handler exibe um toast.
api.interceptors.response.use(
    (r) => r,
    (error) => {
        const status: number | undefined = error?.response?.status;
        // 401 já é tratado no cliente (redireciona); 422 é validação local;
        // 0 é cancelado ou offline e a UI específica costuma cobrir.
        if (status && status !== 401 && status !== 422 && status >= 500) {
            toast.error('A casa não respondeu agora. Tenta de novo em alguns segundos.');
        }
        return Promise.reject(error);
    },
);

// Avisa quando o SW disponibiliza nova versão.
onMounted(async () => {
    if (!('serviceWorker' in navigator)) return;
    try {
        const { registerSW } = await import('virtual:pwa-register');
        registerSW({
            immediate: true,
            onNeedRefresh: () => {
                toast.info('Nova versão disponível. Toque pra atualizar.', 8000);
                setTimeout(() => window.location.reload(), 8500);
            },
        });
    } catch {
        // Em dev sem PWA habilitado o virtual module pode não existir; segue o jogo.
    }
});
</script>

<template>
    <RouterView />
    <ToastHost />
</template>
